export default __webpack_public_path__ + "86d5391a2f99f59922f6be857a6ac9ed.svg";